export default "__VITE_ASSET__DWn$0vks__"